import React, { useEffect, useMemo, useRef, useState } from 'react';
import { List } from 'react-window';
import useAppStore from '../../store';
import { formatClock } from '../../lib/formatters/time';

function LogRow({ index, style, logs }) {
  const entry = logs[index];
  if (!entry) return null;

  return (
    <div className={`log-row log-row--${entry.level}`} style={style}>
      <span className="log-row__time">{formatClock(entry.timestamp)}</span>
      <span className="log-row__level">{entry.level.toUpperCase()}</span>
      <span className="log-row__agent">{entry.agent}</span>
      <span className="log-row__message">{entry.message}</span>
    </div>
  );
}

function LogStreamPanel({ feedMode, visibleLogs }) {
  const logs = visibleLogs;
  const clearLogs = useAppStore((state) => state.clearLogs);
  const [autoScroll, setAutoScroll] = useState(true);
  const listRef = useRef(null);

  useEffect(() => {
    if (autoScroll && listRef.current && logs.length > 0) {
      listRef.current.scrollToRow({ index: logs.length - 1, align: 'end' });
    }
  }, [logs.length, autoScroll]);

  return (
    <div className="log-stream">
      <div className="log-stream__toolbar">
        <span className={`log-stream__feed log-stream__feed--${feedMode}`}>
          {feedMode === 'live' ? 'LIVE SSE' : feedMode === 'demo' ? 'DEMO STREAM' : 'CONNECTING…'}
        </span>
        <span className="log-stream__count">{logs.length.toLocaleString()} lines</span>
        <label className="log-stream__autoscroll">
          <input
            checked={autoScroll}
            onChange={(domEvent) => setAutoScroll(domEvent.target.checked)}
            type="checkbox"
          />
          auto-scroll
        </label>
        <button className="ghost-button" onClick={clearLogs} type="button">Clear</button>
      </div>

      {logs.length === 0 ? (
        <div className="log-stream__empty">Waiting for agent output…</div>
      ) : (
        <List
          className="log-stream__list"
          listRef={listRef}
          rowCount={logs.length}
          rowHeight={24}
          rowComponent={LogRow}
          rowProps={{ logs }}
          style={{ height: '100%' }}
        />
      )}
    </div>
  );
}

export default LogStreamPanel;
